<div class="row summary-block" *ngIf="summaryData.length == 3">
  <div class="col-lg-4 col-xxl-4 mt-3 mt-lg-0" *ngFor="let summary of summaryData">
    <div [ngClass]="{'clickable' : summary.OnClick, 'statcard bg-white border py-1' : true}" (click)="summary.OnClick ? summary.OnClick() : null">
      <h3 class="statcard-value">
        {{summary.Value}}
      </h3>
      <span class="statcard-label text-dark">{{summary.Title}}</span>
    </div>           
  </div>
</div>

<div class="row summary-block" *ngIf="summaryData.length == 4">
  <div class="col-lg-3 col-xxl-3 mt-3 mt-lg-0" *ngFor="let summary of summaryData">
    <div [ngClass]="{'clickable' : summary.OnClick, 'statcard bg-white border py-1' : true}" (click)="summary.OnClick ? summary.OnClick() : null">
      <h3 class="statcard-value">
        {{summary.Value}}
      </h3>
      <span class="statcard-label text-dark">{{summary.Title}}</span>
    </div>           
  </div>
</div>

<div class="row summary-block" *ngIf="summaryData.length == 5">
  <div class="col-lg-2 col-xxl-2 mt-3 mt-lg-0" *ngFor="let summary of summaryData">
    <div [ngClass]="{'clickable' : summary.OnClick, 'statcard bg-white border py-1' : true}" (click)="summary.OnClick ? summary.OnClick() : null">
      <h3 class="statcard-value">
        {{summary.Value}}
      </h3>
      <span class="statcard-label text-dark">{{summary.Title}}</span>
    </div>           
  </div>
</div>

<div class="row summary-block" *ngIf="summaryData.length == 6">
  <div class="col-lg-2 col-xxl-2 mt-3 mt-lg-0" *ngFor="let summary of summaryData">
    <div [ngClass]="{'clickable' : summary.OnClick, 'statcard bg-white border py-1' : true}" (click)="summary.OnClick ? summary.OnClick() : null">
      <h3 class="statcard-value">
        {{summary.Value}}
      </h3>
      <span class="statcard-label text-dark">{{summary.Title}}</span>
    </div>           
  </div>
</div>

<div class="row summary-block" *ngIf="summaryData.length > 6">
  <div class="col-lg-6 col-xxl-3 mt-3 mt-lg-0" *ngFor="let summary of summaryData">
    <div [ngClass]="{'clickable' : summary.OnClick, 'statcard bg-white border py-1' : true}" (click)="summary.OnClick ? summary.OnClick() : null">
      <h3 class="statcard-value">
        {{summary.Value}}
      </h3>
      <span class="statcard-label text-dark">{{summary.Title}}</span>
    </div>           
  </div>
</div>